import {
    PRESUPUESTADOR_GENERATE_SELL_REQUEST_BEGIN,
    PRESUPUESTADOR_GENERATE_SELL_REQUEST_SUCCESS,
    PRESUPUESTADOR_GENERATE_SELL_REQUEST_FAILURE,
    PRESUPUESTADOR_GENERATE_SELL_REQUEST_DISMISS_ERROR,
  } from './constants'
  import axios from 'axios'
  import { PRESUPUESTADOR_ENDPOINT } from 'cfgCommon/endpoints'
  
  export function generateSellRequest() {
    return (dispatch, getState) => {
      // optionally you can have getState as the second argument
      dispatch({
        type: PRESUPUESTADOR_GENERATE_SELL_REQUEST_BEGIN,
      })

      const {presupuestador = {}} = getState()

      const promise = new Promise((resolve, reject) => {

      //Armo el body
      const body = { budget_id: presupuestador.id_presupuesto }
      const doRequest = axios.post(`${PRESUPUESTADOR_ENDPOINT}/generateSale`, body)
  
        doRequest.then(
          (res) => {
            dispatch({
              type: PRESUPUESTADOR_GENERATE_SELL_REQUEST_SUCCESS,
              data: res.data,
            })
            resolve(res)
          },
          // Use rejectHandler as the second argument so that render errors won't be caught.
          (err) => {
            dispatch({
              type: PRESUPUESTADOR_GENERATE_SELL_REQUEST_FAILURE,
              data: { error: err },
            })
            reject(err)
          },
        )
      })
  
      return promise
    }
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissGenerateSellRequestError() {
    return {
      type: PRESUPUESTADOR_GENERATE_SELL_REQUEST_DISMISS_ERROR,
    }
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case PRESUPUESTADOR_GENERATE_SELL_REQUEST_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          generateSellRequestPending: true,
          generateSellRequestError: null,
        }
  
      case PRESUPUESTADOR_GENERATE_SELL_REQUEST_SUCCESS:
        // The request is success
        return {
          ...state,
          ...action.data,
          generateSellRequestPending: false,
          generateSellRequestError: null,
        }
  
      case PRESUPUESTADOR_GENERATE_SELL_REQUEST_FAILURE:
        // The request is failed
        return {
          ...state,
          generateSellRequestPending: false,
          generateSellRequestError: action.data.error,
        }
  
      case PRESUPUESTADOR_GENERATE_SELL_REQUEST_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          generateSellRequestError: null,
        }
  
      default:
        return state
    }
  }
  